define([
	"dojo/_base/declare",
	"csi",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/service/nodeService",
	"csi/state/rootStore",
	"csi/table/New",
	"csi/xml",
	"Apparel/SamplesForm"
], function(declare, csi, Controller, PostRequest, { resolveNodesWithDependencies }, { routerStore }, New, xml, SamplesForm) {
	const FACTORY = "Factory";
	const SUPPLIER = "Supplier";

	return declare(New, {
		// Boolean: default New controller only adds one node - this controller may add many
		bUpdateParent: false,

		// Boolean: validation is handled explicitly
		bValidate: false,

		/**
		 * Add special controller for copy form
		 */
		onCreatePopupDefView: function(defView) {
			defView.classController = SamplesForm;
		},

		getStringParameters: function() {
			// summary: use return value as parameter to success message
			var cntr = this.samples == null ? 0 : this.samples.length;
			return [cntr];
		},

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			// summary: add new url to request
			return this.inherited(arguments, [urlsNew.concat(this.samples)]);
		},

		getNewNodes: function() {
			// summary: get nodes resulting from action for postprocessing
			return this.m_cache.getNodes(this.samples);
		},

		/**
		 * @override
		 * initialize product and supplier on samples form (can be overridden)
		 */
		onCreatePopup: function(view) {
			view.setProduct(routerStore.getBreadcrumbNode("Style") || routerStore.getBreadcrumbNode("Material"));
			const sourceCnl = xml.isValidURL(this.getParent().SupplierFactory) ? this.getParent().SupplierFactory : this.getParent().Supplier;
			view.setSource(sourceCnl, this.getParent().$Name);
		},

		/**
	     * @override
	     */
		async process() {
			const fd = this.m_formData;

			// make the source node in cache
			const sources = fd.getFieldValue(FACTORY, true) || fd.getFieldValue(SUPPLIER, true);
			
			await resolveNodesWithDependencies(Array.isArray(sources)? sources : [sources], ["Child:Factory"], this.m_cache);	
			
			// special logic only applies if dimensions (RequestSampleDimensions) = "sample per active color" (5)
			if (fd.getFieldValue("RequestSampleDimensions") != 5) {
				return Controller.prototype.process.call(this);
			}

			// select active colorways to this.activeColorways from selected SR line items
			var req;

			if (fd.getFieldValue("SampleSRLineItem")) {
				req = new PostRequest("Sourcing", "GetActiveProductColorsFromLineItems", {
					LineItems: fd.getFieldValue("SampleSRLineItem")
				});
			} else {
				// see if urlParent is a Product or ProductSource.
				var p = this.m_cache.getNode(this.m_urlParent);

				req = new PostRequest("Sourcing", "GetActiveProductColorsFromProduct", {
					Product: (p.$Type == "ProductSource" ? p.AvailabilityProduct : p.$URL)
				});
			}

			var self = this;

			req.post().then(function(response) {
				self.popupView._productColors = csi.hashArray(response.getResultNodes(), "Product", "ProductColor", null, true);

				New.prototype.process.call(self);
			});
		},

		toWriter: function() {
			// summary: create samples according to form and add to source
			this.samples = this.popupView.toWriterSamples(this);
		},

		_canNavigate: function() {
			// summary: disable Save & Go since action can create multiple samples
			return false;
		}
	});
});